<template>
  <b-form-checkbox-group
    v-model="internalValue"
    :options="options"
    :state="state"
    :disabled="disabled"
    :size="size"
    stacked
    @input="handleInput"
  />
</template>

<script>
export default {
  name: 'CheckboxField',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      required: true
    },
    state: {
      type: Boolean,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      internalValue: this.value
    }
  },
  methods: {
    handleInput(value) {
      !this.disabled && this.$emit('input', value)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
